import type en from '../en/subscriptions'
import type { Translation } from '../types'

/** Alert subscriptions: who is told when a network or device goes offline */
const subscriptions: Translation<typeof en> = {
  "subscriptions.scope.SITE": "Alleen het netwerk",
  "subscriptions.scope.SITE_AND_DEVICES": "Netwerk + apparaten",
  "subscriptions.scope.DEVICE": "Eén apparaat",
  "subscriptions.blurb.SITE": "Melding wanneer de locatie zelf offline gaat",
  "subscriptions.blurb.SITE_AND_DEVICES": "Ook meldingen voor elk apparaat erin",
  "subscriptions.blurb.DEVICE": "Meldingen voor één apparaat",
  "subscriptions.blurbDevices": { one: "Ook meldingen voor elk apparaat erin ({count} apparaat)", other: "Ook meldingen voor elk apparaat erin ({count} apparaten)" },
  "subscriptions.channel.EMAIL": "E-mail",
  "subscriptions.unsubscribed": "Afgemeld",
  "subscriptions.testSent": "Test verstuurd via {channels}",
  "subscriptions.someFailed": "Sommige kanalen zijn mislukt",
  "subscriptions.testFailed": "Test mislukt",
  "subscriptions.title": "Abonnementen op meldingen",
  "subscriptions.subtitle": "Hoor het wanneer een netwerk of apparaat offline gaat",
  "subscriptions.subscribe": "Abonneren",
  "subscriptions.noPhone": "Geen telefoonnummer ingesteld",
  "subscriptions.ready": "klaar",
  "subscriptions.unavailable": "niet beschikbaar",
  "subscriptions.empty": "Nog geen abonnementen. Abonneer u op een netwerk om te horen wanneer het uitvalt.",
  "subscriptions.unknown": "Onbekend",
  "subscriptions.paused": "gepauzeerd",
  "subscriptions.alertsAfter": "Melding na {duration} storing",
  "subscriptions.reminderEvery": "Herinnering elke {duration}",
  "subscriptions.reminderEveryMax": "Herinnering elke {duration} (hooguit {max})",
  "subscriptions.oneMessage": "Eén bericht per storing",
  "subscriptions.recoveryOn": "Herstelbericht aan",
  "subscriptions.quiet": "Stil {from}–{to}",
  "subscriptions.muted": "Gedempt:",
  "subscriptions.unmute": "Dempen opheffen",
  "subscriptions.unmuted": "{name} niet meer gedempt",
  "subscriptions.mutedName": "{name} gedempt",
  "subscriptions.muteDevice": "Een apparaat in dit netwerk dempen",
  "subscriptions.history": "Verzendgeschiedenis",
  "subscriptions.sendTest": "Een test versturen",
  "subscriptions.unsubscribe": "Afmelden",
  "subscriptions.unsubscribeConfirm": "Afmelden voor deze meldingen?",
  "subscriptions.historyEmpty": "Nog geen meldingen verstuurd — er is niets offline gegaan sinds u zich abonneerde.",
  "subscriptions.target": "Doel",
  "subscriptions.downSince": "Offline sinds",
  "subscriptions.messages": "Berichten",
  "subscriptions.state": "Status",
  "subscriptions.reminders": { one: "({count} herinnering)", other: "({count} herinneringen)" },
  "subscriptions.state.PENDING": "wacht",
  "subscriptions.state.NOTIFIED": "verstuurd",
  "subscriptions.state.RECOVERED": "hersteld",
  "subscriptions.newTitle": "Abonneren op meldingen",
  "subscriptions.network": "Netwerk *",
  "subscriptions.chooseNetwork": "Kies een netwerk…",
  "subscriptions.watchWhat": "Wat wilt u volgen?",
  "subscriptions.device": "Apparaat *",
  "subscriptions.chooseDevice": "Kies een apparaat…",
  "subscriptions.sendVia": "Meldingen versturen via *",
  "subscriptions.rcsNote": "RCS komt aan in de berichtenapp van de telefoon zelf. Het bereikt iPhones in Nederland nog niet.",
  "subscriptions.rcsNoteTwilio": "RCS komt aan in de berichtenapp van de telefoon zelf. Het bereikt iPhones in Nederland nog niet; met een sms-nummer in de Twilio-service krijgen zij een sms.",
  "subscriptions.howOften": "Hoe vaak",
  "subscriptions.wait": "Wachten voor de melding",
  "subscriptions.waitHint": "minuten — negeert korte haperingen en herstarts",
  "subscriptions.remind": "Herinner mij zolang het offline blijft",
  "subscriptions.remindHint": "Standaard uit — u krijgt precies één bericht per storing.",
  "subscriptions.every": "elke",
  "subscriptions.remindEvery": "Herinner elke",
  "subscriptions.stopAfter": "stop na",
  "subscriptions.stopAfterLabel": "Stop na dit aantal herinneringen",
  "subscriptions.remindersWord": "herinneringen",
  "subscriptions.recovers": "Laat het mij weten wanneer het herstelt",
  "subscriptions.recoversHint": "Eén bericht wanneer het weer online komt",
  "subscriptions.quietHours": "Stille uren",
  "subscriptions.quietHint": "Berichten worden vastgehouden tot het venster voorbij is",
  "subscriptions.quietStart": "Begin van de stille uren",
  "subscriptions.quietEnd": "Einde van de stille uren",
  "subscriptions.to": "tot",
  "subscriptions.subscribed": "Geabonneerd",
  "subscriptions.subscribeFailed": "Abonneren is niet gelukt",
  "subscriptions.devicesIn": "Apparaten in {name}",
  "subscriptions.muteInfo": "Demp een apparaat om de meldingen ervan te stoppen terwijl de rest van het netwerk geabonneerd blijft.",
  "subscriptions.noDevices": "Geen apparaten gevonden in dit netwerk",
  "subscriptions.unmuteTitle": "Dempen opheffen — meldingen hervatten",
  "subscriptions.muteTitle": "Dempen — meldingen voor dit apparaat stoppen",
  "subscriptions.mute": "Dempen",
  "subscriptions.done": "Klaar",
  "subscriptions.notChanged": "Niet gewijzigd",
  "subscriptions.channel.PUSH": "Push (telefoon-app)",
  "subscriptions.pushPhones": "Telefoons met pushmeldingen: {n}",
  "subscriptions.pushFirst.first": {"one": "Push gaat eerst. {channel} volgt na {count} minuut als u de locatie niet hebt geopend.", "other": "Push gaat eerst. {channel} volgt na {count} minuten als u de locatie niet hebt geopend."},
  "subscriptions.pushFirst.atOnce": "{channel} gaat meteen: op geen van uw telefoons is push toegestaan (Profiel → Telefoon-app).",
  "subscriptions.pushFirst.automatic": "Push wordt hoe dan ook eerst verstuurd voor uw WhatsApp- en RCS-meldingen.",
}

export default subscriptions
